import Fingerprint2, { Component } from 'fingerprintjs2';
import store from '@/store';

/**
 * Simple handy plugin to create a browser based fingerprint through using the
 * https://github.com/Valve/fingerprintjs2 library.
 *
 * All available options:
 * https://github.com/Valve/fingerprintjs2/wiki/Browser-independent-components
 * https://github.com/Valve/fingerprintjs2/wiki/Stable-components
 */
const defaultOptions = {
    excludes: {
        adBlock: true,
        fonts: true,
        plugins: true,
        // webglVendorAndRenderer: true,
        availableScreenResolution: true,
        screenResolution: true,
        userAgent: true,
        canvas: true,
        webgl: true,
        audio: true,
        colorDepth: true,
        // ATTENTION: these are default excluded components from fingerprint,
        // unfortunately these are not merged with custom exclusions
        enumerateDevices: true,
        // devicePixelRatio depends on browser zoom, and it's impossible to detect browser zoom
        pixelRatio: true,
        // DNT depends on incognito mode for some browsers (Chrome) and it's impossible to detect incognito mode
        doNotTrack: true,
        // uses js fonts already
        fontsFlash: true
    },
    extraComponents: [
        {
            key: 'userKey',
            getData: (done: any) => {
                const userData = store.getters['auth/currentUser'];
                let value = 'no_user';
                if (userData) {
                    value = `${userData.email}.${userData.password}`;
                }
                done(value);
            }
        }
    ]
};

const HASH_SEED: number = 33;
const INITIAL_DELAY: number = 500;
let isInitialized: boolean = false;
let installTimeStamp!: number;

const FingerprintPlugin = {
    install(Vue: any, options: any = {}) {
        installTimeStamp = Date.now();

        /**
         * Returns a strong fingerprint which considers localstorage values also
         */
        const getFingerprint = async () => {
            // add delay for first initialization
            if (!isInitialized && (Date.now() - installTimeStamp) < INITIAL_DELAY) {
                // timeDelta is the difference between delay and the time between plugin install and first call.
                const timeDelta = INITIAL_DELAY - (Date.now() - installTimeStamp);
                await new Promise(resolve => {
                    setTimeout(() => resolve(), timeDelta);
                });
            }
            isInitialized = true;
            const pluginOptions = Object.assign(defaultOptions, options);
            const components = await Fingerprint2.getPromise(pluginOptions);
            const componentValues = components.map((component: Component) => component.value).join('');
            return Fingerprint2.x64hash128(componentValues, HASH_SEED);
        };

        Vue.prototype.$getFingerprint = getFingerprint;
        Vue.getFingerprint = getFingerprint;
    }
};
export default FingerprintPlugin;
